import { BookingCompressed } from '@jooxter/api';

export const shouldBookingBeRefused = (booking: BookingCompressed): boolean => {
  return Boolean(!booking.capabilities?.cancel && !booking.capabilities?.update && booking.capabilities?.participate);
};
